import { render, staticRenderFns } from "./CustomerBuildingList.vue?vue&type=template&id=53f1e0ca&scoped=true&"
import script from "./CustomerBuildingList.vue?vue&type=script&lang=js&"
export * from "./CustomerBuildingList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBuildingList.vue?vue&type=style&index=0&id=53f1e0ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f1e0ca",
  null
  
)

export default component.exports